import {useEffect} from 'react'
import {Util} from 'yougile-util'
import {sharingGuestAccount} from 'yougile-model'
import {Accounts} from '@client/accounts'
import {PaymentClient} from '@client/payment-client'
import {getUserAccountName} from '@components/user-name'
import {useForceUpdate, useGuestInfo} from '@containers/hooks'
import {globals} from '@extensions/globals-base'
import {UserType, UseUser, UseUserOptions} from './types'

export const useUserName = ({
  user,
  userId,
  guestId,
  task,
  nameOverride
}: UseUserOptions): UseUser => {
  const id = user?.id ?? userId
  const guestInfo = useGuestInfo(guestId)
  const userName = userId && getUserAccountName({id: userId}, task)
  const realName = guestInfo?.name ?? userName

  let type: UserType = 'normal'
  if ((!id || id === sharingGuestAccount.id) && guestId) {
    type = 'guest'
  }
  if (Util.isEmail(realName)) {
    type = 'not-registered'
  }
  if (id && PaymentClient.isUserDisallowed(globals.getCompanyId(), id)) {
    type = 'disallowed'
  }

  const forceUpdate = useForceUpdate()
  useEffect(() => {
    if (!id) {
      return Util.noop
    }

    const accountHid = Accounts.addListener({account: id, cb: forceUpdate})
    const paymentHid = PaymentClient.addListener(forceUpdate)
    return () => {
      Accounts.removeListener(accountHid)
      PaymentClient.removeListener(paymentHid)
    }
  }, [id])

  return {type, name: nameOverride ?? realName}
}
